import { Injectable } from "@angular/core";
import {
  CoreActionFactory, START_BACKEND_COMMUNICATION, END_BACKEND_COMMUNICATION, RESET_REDUX_STATE, START_NAVIGATION,
  END_NAVIGATION, CHANGE_NAVIGATION_ENABLED_STATE, SET_APP_LOCALE
} from "./core.action.factory";
import { ReduxAction } from "../../model/redux.action.model";
import { Store } from "@ngrx/store";

@Injectable()
export class CoreActionFactoryImpl implements CoreActionFactory {

  protected _ngrxStore: Store<any>;

  constructor(ngrxStore: Store<any>) {
    this._ngrxStore = ngrxStore;
  }

  public startBackendCommunication(): void {
      this._ngrxStore.dispatch(this.getStartBackendCommunicationAction());
  }

  public endBackendCommunication(): void {
      this._ngrxStore.dispatch(this.getEndBackendCommunicationAction());
  }


  resetState(): void {
      this._ngrxStore.dispatch(this.getResetStateAction());
  }

  public startNavigation(): void {
      this._ngrxStore.dispatch(this.getStartNavigationAction());
  }

  public endNavigation(): void {
      this._ngrxStore.dispatch(this.getEndNavigationAction());
  }

  public changeNavigationEnabledState(enabled: boolean): void {
      this._ngrxStore.dispatch(this.getChangeNavigationEnabledStateAction(enabled));
  }

  public setLocale(locale: string): void {
      this._ngrxStore.dispatch(this.getSetLocaleAction(locale));
  }

  protected getStartBackendCommunicationAction(): ReduxAction<any> {
      return {
          type: START_BACKEND_COMMUNICATION
      };
  }

  protected getEndBackendCommunicationAction(): ReduxAction<any> {
      return {
          type: END_BACKEND_COMMUNICATION
      };
  }

  protected getResetStateAction(): ReduxAction<any> {
      return {
          type: RESET_REDUX_STATE
      };
  }

  protected getStartNavigationAction(): ReduxAction<any> {
      return {
          type: START_NAVIGATION
      };
  }

  protected getEndNavigationAction(): ReduxAction<any> {
      return {
          type: END_NAVIGATION
      };
  }

  protected getChangeNavigationEnabledStateAction(enabled: boolean): ReduxAction<any> {
      return {
          type: CHANGE_NAVIGATION_ENABLED_STATE,
          payload: enabled
      };
  }

  protected getSetLocaleAction(locale: string): ReduxAction<string> {
    return {
      type: SET_APP_LOCALE,
      payload: locale
    };
  }
}
